/**
 * Ключи localStorage, используемые больше чем в одном модуле — отдельный
 * файл без зависимостей, чтобы не создавать циклический импорт между
 * AppLayout (меню) и AuthContext (сброс раскрытых групп при входе).
 */
export const OPEN_GROUPS_KEY = 'tms.sidebarOpenGroups';
